(function () {
  if (window.tpDeliveryCheckerLoaded) return;
  window.tpDeliveryCheckerLoaded = true;

  var zoneBothSlots = ['L4C','L4B','L3T','L4J','L6C','L3R','L6G','M1H','M1P','M1R','M1T','M1S','M1V','M1W','M2R','M3H','M2M','M2N','M2K','M2H','M2J','M2L','M2P','M3B','M3A','M4A','M3C','M4N','M5M','L4S','M1X','M1B','M1C','M1E','M1G','M1J','M1M','M1K','M1L','M1N','M4J','M4L','M4E','M4C','M4B','M4V','M4T','M4S','M4G','M4H','M4P','M4R','M5N','L6B','L3P','L6E','L3S','M5R','M4W','M5S','M7A','M4Y','M4X','M5A','M5B','M5G','M5T','M5C','M5H','M5V','M5J','M5E','M4K','M4M','M5K'];
  var zoneEveningOnly = ['L4E','L4G','L3X','L3Y','L7B','L6A','L4K','L3L','L4H','L4L','L0J','M3N','M3J','M3L','M3M','M3K','M6L','M6M','M6N','M6G','M6J','M6K','M6H','M6R','M6P','M8X','M9A','M9P','M9R','M9N','M9W','M9M','M9V','M9L','M6A','M6B','M6E','M6C','M5P','L4T','L4V','L4W','L4X','L4Y','L4Z','L5A','L5B','L5C','L5E','L5G','L5H','L5J','L5K','L5L','L5M','L5N','L5P','L5R','L5S','L5T','L5V','L5W','L6H','L6J','L6K','L6M','L6L','M8V','M8Y','M8Z','M8W','M9C','M9B','M6S','L6P','L6R','L6X','L6Y','L6S','L6T','L6W','L6V','L6Z','L7A'];
  var zoneStouffville = ['L4A'];
  var zoneHamilton = ['L8P','L8H','L8K','L8L','L8M','L8N','L8R','L9C','L8S','L8T','L8V','L8W','L9A','L9B','L9H','L9K','L9G','L7L','L7M','L7N','L7R','L7S','L7T'];
  var zoneWaterloo = ['N2J','N2K','N2L','N2T','N2V','N0B','N2A','N2B','N2C','N2E','N2G','N2H','N2M','N2N','N2P','N2R','N1E','N1G','N1H','N1K','N1L'];
  var bramptonPrefixes = ['L6P','L6R','L6X','L6Y','L6S','L6T','L6W','L6V','L6Z','L7A'];

  function renderResult(result, message, success) {
    result.innerHTML = message;
    result.classList.add('is-visible');
    result.classList.toggle('is-success', success);
    result.classList.toggle('is-error', !success);
  }

  function normalizePostalCode(value) {
    return (value || '').replace(/[^a-z0-9]/gi, '').toUpperCase().slice(0, 3);
  }

  function bindChecker(checker) {
    if (checker.dataset.tpDeliveryCheckerReady === 'true') return;
    checker.dataset.tpDeliveryCheckerReady = 'true';

    var input = checker.querySelector('input[name="postal_code"]');
    var result = checker.querySelector('[data-tp-delivery-result]');
    if (!input || !result) return;

    checker.addEventListener('submit', function (event) {
      event.preventDefault();

      var fsa = normalizePostalCode(input.value);
      if (fsa.length < 3) {
        renderResult(result, '<strong>Enter the first 3 characters of your postal code.</strong> Example: M5V, L3R, or M2N.', false);
        return;
      }

      if (zoneBothSlots.indexOf(fsa) !== -1) {
        renderResult(result, '<strong>Delivery is likely available for ' + fsa + '.</strong><br>Afternoon and evening delivery windows may be available. Current eligible core GTA offer: $4.95 + tax on orders $30+. Free delivery may apply over $79. Final options are confirmed in cart.', true);
        return;
      }

      if (zoneEveningOnly.indexOf(fsa) !== -1) {
        var feeText = bramptonPrefixes.indexOf(fsa) !== -1 ? 'This postal code has its own current offer: $6.95 + tax, free over $79 where eligible.' : 'Current eligible core GTA offer: $4.95 + tax on orders $30+. Free delivery may apply over $79.';
        renderResult(result, '<strong>Evening delivery is likely available for ' + fsa + '.</strong><br>' + feeText + ' Final options are confirmed in cart.', true);
        return;
      }

      if (zoneStouffville.indexOf(fsa) !== -1) {
        renderResult(result, '<strong>Selected-day delivery is likely available for ' + fsa + '.</strong><br>Stouffville route: Monday and Friday evening delivery. Final date and pricing are confirmed in cart.', true);
        return;
      }

      if (zoneHamilton.indexOf(fsa) !== -1) {
        renderResult(result, '<strong>Selected-day delivery is likely available for ' + fsa + '.</strong><br>Hamilton and Burlington route: Tuesday, Thursday, and Sunday evening delivery. Final date and pricing are confirmed in cart.', true);
        return;
      }

      if (zoneWaterloo.indexOf(fsa) !== -1) {
        renderResult(result, '<strong>Selected-day delivery is likely available for ' + fsa + '.</strong><br>Waterloo, Kitchener, and Guelph route: Wednesday and Saturday evening delivery. Final date and pricing are confirmed in cart.', true);
        return;
      }

      renderResult(result, '<strong>Delivery may not be available for ' + fsa + '.</strong><br>You can still choose free pickup from our Markham studio, or contact us to confirm special options.', false);
    });
  }

  function init() {
    document.querySelectorAll('[data-tp-delivery-checker]').forEach(bindChecker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
